
function encodeURL(object) {

    let parameters = [];

    for (let property in object) {
        if (object.hasOwnProperty(property)) {
            parameters.push(encodeURI(property + '=' + object[property]));
        }
    }
    return parameters.join('&')

}


function encodeURLNew(object) {

    let parameters = {};

    for (let property in object) {
        if (object.hasOwnProperty(property)) {

            if (Array.isArray(object[property])) {
                parameters[property] = object[property].join(',');
            } else {
                parameters[property] = object[property];
            }


        }
    }
    return parameters

}

function getRatingStarsSvg(n, rating) {
    try {

        if (!rating) return 'star_empty_green_sm'

        const fullStars = Math.floor(rating)
        const decimal = parseFloat(rating - fullStars).toFixed(1)

        if (n <= fullStars) {
            return 'star_green_sm' // full star
        } else if (n === fullStars + 1 && decimal >= 0.2 && decimal < 0.7) {
            return 'star_green_half_sm' // half star
        } else if (n === fullStars + 1 && decimal >= 0.7) {
            return 'star_green_sm' // round up to full
        } else {
            return 'star_empty_green_sm' // empty star
        }
    } catch (error) {
        console.log(error)
    }
}



export { encodeURLNew, encodeURL, getRatingStarsSvg };